module.exports = __webpack_public_path__ + "img/re-result-4.91d9107e.jpg";